import { LitElement, html, css } from 'lit';
import { query, property, customElement } from 'lit/decorators.js';
import '../../elements/langhout-button/langhout-button';
import { showNotification, refreshTasksEvent } from '../../LanghoutBetonApp';
import { authenticatedAPICall } from '../../client/api-client';

@customElement('add-comment')
export class AddComment extends LitElement {
  static styles = css`
    :host {
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.1);
    }

    :host([disableButtons]) {
      pointer-events: none;
      opacity: 0.7;
    }

    .row {
      display: flex;
      flex-direction: row;
    }

    .centered {
      justify-content: center;
      align-items: center;
    }

    .outer-wrapper {
      width: 100vw;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .wrapper {
      padding-top: 30px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 40px;
      border-radius: 10px;
      background-color: var(--background-color);
      border: 1px solid var(--primary-color);
      display: flex;
      flex-direction: column;
      min-width: 60vw;
    }

    input {
      padding: 7px;
      width: calc(100% - 18px);
      border-radius: 5px;
      font-size: 16px;
      width: 200px;
    }

    langhout-button {
      margin-top: 25px;
      width: 218px;
    }

    h2 {
      margin: 0px;
      margin-bottom: 30px;
    }
  `;

  @property({ type: Boolean, reflect: true })
  private disableButtons = false;

  @query('#comment')
  public commentInput?: HTMLInputElement;

  @property({ type: String, attribute: true, reflect: true })
  public url = '';

  constructor() {
    super();
  }

  public focus = () => {
    if (this.commentInput) {
      this.commentInput.focus();
    }
  };

  render() {
    return html`
      <div class="outer-wrapper">
        <div class="row centered">
          <div class="wrapper">
            <h2>Opmerking toevoegen</h2>
            <div class="row centered">
              <input
                type="text"
                id="comment"
                name="comment"
                placeholder="Opmerking"
                @keypress=${(e: KeyboardEvent) => {
                  if (e.key === 'Enter') {
                    this.addComment();
                  }
                }}
              />
            </div>
            <div class="row centered">
              <langhout-button
                text="Opmerking plaatsen"
                @click="${() => {
                  this.addComment();
                }}"
              ></langhout-button>
            </div>
            <div class="row centered">
              <langhout-button
                reverse
                text="Annuleren"
                @click="${() => {
                  this.dispatchCloseEvent();
                }}"
              ></langhout-button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  addComment = async () => {
    this.disableButtons = true;
    const message = this.commentInput ? this.commentInput.value : '';
    if (message === '') {
      this.disableButtons = false;
      showNotification('Opmerking kan niet leeg zijn');
      return;
    }
    await this.addCommentCall(message);
    this.disableButtons = false;
  };

  addCommentCall = async (message: string) => {
    const commentPayload = {
      message: message,
      type: 'app',
    };
    const path = this.url;
    const result = await authenticatedAPICall(
      path,
      'POST',
      new Headers(),
      JSON.stringify(commentPayload),
    );

    if (result.statusCode !== undefined && result.statusCode >= 200 && result.statusCode < 300) {
      showNotification('Opmerking toegevoegd');

      refreshTasksEvent();
      this.dispatchCloseEvent();
    }
  };

  dispatchCloseEvent = () => {
    if (this.commentInput) {
      this.commentInput.value = '';
    }
    const event = new CustomEvent('close', {
      detail: {},
    });
    this.dispatchEvent(event);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'add-comment': AddComment;
  }
}
